export default __webpack_public_path__ + "static/media/330_dummy2016-moebelbauer01-mobile-de.d4e744fb.png";